import React, { useState, useRef, useEffect } from 'react';
import dropdown from '../icons/dropdown.svg'

const RichSelect = ({options, handleChange}) => {
  const [selected, setSelected] = useState(0);
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  console.log(options)
  const handleToggle = () => {
    setIsOpen(!isOpen);
  };

  const handleOptionClick = (option) => {
    setSelected(option);
    handleChange(option)
    setIsOpen(false);
  };

  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setIsOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener('click', handleClickOutside);
    return () => document.removeEventListener('click', handleClickOutside);
  }, []);

  return (
    <div className="rich-select" ref={dropdownRef}>
      <div className="selected-option rich-select-option" onClick={handleToggle}>
        <span className="rich-select-title">
          {options[selected].name}
          <img src={dropdown} style={{width: "20px", float: 'right', marginRight: "12px"}}></img>
        </span>
        <span className="rich-select-description">{options[selected].description}</span>
      </div>
      {isOpen && (
        <div className="options-container">
          {options.map((option, index) => {
            if(!(selected == index)) {
              return (
                <div
                  key={index}
                  className="rich-select-option rich-select-option-unselected"
                  onClick={() => handleOptionClick(index)}
                >
                  <span className="rich-select-title">{option.name}</span>
                  <span className="rich-select-description">{option.description}</span>
                </div>
              )
            }
          })}
        </div>
      )}
    </div>
  );
};

export {
  RichSelect
}
